import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function CCU() {
    return (
        <div>
            <Header/>
        <DetailService
            titre="Méthodes de Conception Centrée Utilisateur"
            categorie="Cognitique"
            image="/images/cognitique2.avif"
            description="Nos méthodes de Conception Centrée Utilisateur, telles que la veille technologique, les questionnaires, les entretiens et les tests utilisateurs, sont rigoureusement appliquées par nos intervenants. Grâce à notre approche, nous proposons des idées novatrices basées sur les retours des utilisateurs en prenant en compte leurs besoins tout au long du projet. En d’autres termes, si un client a une idée précise au départ, elle ne correspondra pas forcément aux attentes réelles des utilisateurs une fois concrétisée."
            etapes={[
                {
                    numero: 1,
                    titre: 'Cadrage du besoin client',
                    texte: 'Définition des objectifs de l\'étude, identification des utilisateurs cibles et des questions auxquelles la recherche doit répondre. Nous choisissons ensemble les méthodes les plus adaptées.',
                },
                {
                    numero: 2,
                    titre: 'Collecte de données utilisateurs',
                    texte: 'Mise en œuvre des méthodes sélectionnées : questionnaires en ligne, entretiens individuels, focus groups ou observations en situation réelle. Les données sont collectées rigoureusement.',
                },
                {
                    numero: 3,
                    titre: 'Analyse et synthèse',
                    texte: 'Traitement et interprétation des données recueillies pour identifier les besoins, attentes, difficultés et comportements des utilisateurs. Les résultats sont synthétisés en insights actionnables.',
                },
                {
                    numero: 4,
                    titre: 'Tests utilisateurs',
                    texte: 'Évaluation du système ou de l\'interface existante ou prototypée avec de vrais utilisateurs, afin de détecter les problèmes d\'ergonomie et valider les solutions envisagées.',
                },
                {
                    numero: 5,
                    titre: 'Restitution et recommandations',
                    texte: 'Présentation des résultats au client sous forme de rapport structuré, avec des recommandations concrètes et priorisées pour améliorer le système ou l\'interface.',
                },
            ]}
            realisations={[
             
            ]}
        />
         <Footer/>
        </div>
    );
}

export default CCU;
